import styled from 'styled-components'

import { ImageCustom } from '@/components/shared/image'
import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { HeadlineText } from '@/ui/atoms/headline-text'

export const Wrapper = styled.li`
  position: relative;
`
export const Container = styled.section(
  ({ theme }) => `
  padding: 0 0 ${theme.spacing.default} 0;
`
)

export const Viewport = styled.div`
  overflow: hidden;
`

export const Heading = styled(HeadlineText)(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.default};
  `
)

type ListProps = {
  items: number
}

export const List = styled.ul<ListProps>(
  ({ theme, items }) => `
  display: flex;
  flex-direction: row;
  height: auto;
  gap: ${theme.spacing.default};
  transition: transform .5s;
  padding: ${theme.spacing.mini} 0;

  > li {
    flex: 0 0 calc(${100 / items}% - ${theme.spacing.default});
  }
`
)

export const Dots = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${theme.spacing.defaultSmall} 0;
  `
)

type DotProps = {
  selected: boolean
}

export const Dot = styled.button<DotProps>(
  ({ theme, selected }) => `
    width: ${theme.spacing.large};
    height: ${theme.spacing.large};
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding: 0.5rem;

    &:after {
      background-color: ${selected ? theme.colors.grey.dark1 : 'none'};
      border-radius: ${theme.borderRadius.rounded};
      width: 1rem;
      height: 1rem;
      content: '';
      box-sizing: border-box;
      border: .2rem solid ${theme.colors.grey.dark1};
    }
  `
)

type PrevNextBtnProps = {
  next?: boolean
  prev?: boolean
}

export const PrevNextBtn = styled.button<PrevNextBtnProps>(
  ({ theme, next, prev, disabled }) => `
  z-index: ${zIndexRegistry.MAIN_MENU};
  color: ${theme.colors.grey.dark1};
  position: absolute;
  display: ${disabled ? 'none' : 'flex'};
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: ${theme.spacing.husky};
  height: ${theme.spacing.husky};
  right: ${next ? '-1rem' : 'auto'};
  left: ${prev ? '-1rem' : 'auto'};
  background-color: ${theme.colors.purple.primary};
  border-radius: ${theme.borderRadius.rounded};
  border: .1rem solid white;

  &:hover {
    background-color: ${theme.colors.purple.dark1};
    border-width: .2rem;
    filter: drop-shadow(0 .2rem ${theme.spacing.mini} rgba(0, 0, 0, 0.2));
  }

  & > svg {
    width: 40%;
    height: 40%;
    fill: ${theme.colors.white};
  }
  `
)

export const ListingTileImage = styled(ImageCustom)(
  ({ theme }) => `
  border-top-left-radius: ${theme.borderRadius.small};
  border-top-right-radius: ${theme.borderRadius.small};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
)

export const ListingTilePriceDrop = styled.s(
  ({ theme }) => `
  color: ${theme.colors.grey.light1};
  text-decoration: line-through;
`
)
